import SectionHeader from '@components/ui/SectionHeader'
import styles from './styles.module.scss'
import { formatDate } from '@helpers/utils'
import { useAuth } from '@api/accounts/auth/hooks/useAuth'
import LoginLink from '../LoginLink'

const IMAGES = {
  desktopLarge: '/static/images/account/acc-banner-desktop-xl-min.jpg',
  desktop: '/static/images/account/acc-banner-desktop-min.jpg',
  tablet: '/static/images/account/acc-banner-tablet-min.jpg',
  mobile: '/static/images/account/acc-banner-mobile-min.jpg'
}

function HeroBannerImage() {
  return (
    <picture className={styles.HeroBannerImage}>
      <source media="(min-width: 1600px)" srcSet={IMAGES.desktopLarge} />
      <source
        media={`(min-width: 1281px)${
          IMAGES.desktopLarge ? ` and (max-width: 1599px)` : ''
        }`}
        srcSet={IMAGES.desktop}
      />
      <source
        media="(min-width: 1000px) and (max-width: 1280px)"
        srcSet={IMAGES.desktop}
      />
      <source
        media="(min-width: 600px) and (max-width: 1000px)"
        srcSet={IMAGES.tablet}
      />
      {/* eslint-disable-next-line @next/next/no-img-element -- art-directed <picture>/<source> swaps a different file per breakpoint; next/image doesn't support this pattern */}
      <img alt="Account Banner" src={IMAGES.mobile} />
    </picture>
  )
}

function HeroBannerDetails() {
  const { userProfile } = useAuth()

  return (
    <div className={styles.HeroBannerDetails}>
      <SectionHeader
        title={`${
          userProfile?.firstName
            ? `Hello, ${userProfile.firstName}`
            : 'My Account'
        }`}
        variant="left_aligned"
        className={styles.HeroBannerTitle}
      />
      <div className={styles.HeroBannerDetails__copy}>
        {userProfile?.creationDate && (
          <p>SPOKEsman since {formatDate(userProfile.creationDate)}</p>
        )}
        <div className={styles.HeroBannerDetails__logout}>
          <LoginLink variant="white" />
        </div>
      </div>
    </div>
  )
}

export default function HeroBanner() {
  return (
    <div className={styles.HeroBanner}>
      <HeroBannerDetails />
      <HeroBannerImage />
    </div>
  )
}
